import { usePostApiTimesheetsDuplicate, } from '../../generated/sitComponents';
import { calculateHours } from '../timesheet-entry/billable';
import { setTimesheetsQueryData, timesheetsQueryKey, } from '../timesheets/query';
export function usePostTimesheetDuplicate(options) {
    return usePostApiTimesheetsDuplicate({
        ...options,
        onSuccess: async (data, variables, onMutateResult, context) => {
            setTimesheetsQueryData(context.client, (old) => {
                if (!old)
                    return old;
                // Add the new timesheet to the cache
                // We want to add to the beginning of the list.
                const ts = {
                    ...data,
                    ...calculateHours(data.entries),
                };
                return [ts, ...old];
            });
            // Invalidate the cache to force a refetch
            await context.client.invalidateQueries({ queryKey: timesheetsQueryKey });
            await options?.onSuccess?.(data, variables, onMutateResult, context);
        },
    });
}
//# sourceMappingURL=use-post-timesheet-duplicate.js.map